import React, { useEffect } from 'react';
import styled from 'styled-components';
import { UiGrid, UiIconMaterial, UiText } from '@open-stack/ui';
import { useToggle } from '../../../hooks/toggle';
import { LocationPage } from '../../../pages/location/LocationPage';
import { XButton } from '../../x/button/XButton';
import { XCard } from '../../x/card/XCard';
import { XDrawerBottom } from '../../x/drawer-bottom/XDrawerBottom';
import { XRouterRedirect } from '../../x/router/redirect/XRouterRedirect';
import { useUserSession } from '../../../hooks/user-session';
import { Location } from '../../../XV2';

const Wrapper = styled(XCard)`
    color: var(--x-color-success);
    text-align: center;
    font-size: var(--UiText-font-size-2);

    .UiIconMaterial {
        font-size: 5rem;
    }
`;

interface Props {
    tagId: number;
    location: Location;
}

export function TagMenuOutletProductsShow({ tagId, location }: Props) {
    const [isClosed, toggleIsClosed] = useToggle();

    const { claimTagId } = useUserSession();

    useEffect(() => {
        claimTagId(tagId);
    }, [tagId]);

    if (isClosed) {
        return <XRouterRedirect pageOrPath={LocationPage} params={{ locationId: location.id }} />;
    }

    return (
        <XDrawerBottom onClose={toggleIsClosed}>
            <Wrapper>
                <UiGrid padding={4} gap={4}>
                    <UiGrid>
                        <UiIconMaterial>check_circle</UiIconMaterial>

                        <UiText color="text-secondary">You have now access to additional products at:</UiText>

                        <UiText fontSize={4} weight={3}>
                            {location.name}
                        </UiText>
                    </UiGrid>

                    <XButton onClick={toggleIsClosed}>Close</XButton>
                </UiGrid>
            </Wrapper>
        </XDrawerBottom>
    );
}
